
export const mobSidebarDrawer = {
    display: { xs: "flex", md: "none" },
    width: "300px",
    overflow: 'hidden',
    '& .MuiDrawer-paper':
    {
        overflow: 'hidden',
        background: "white",
        height: '100%',
        width: '320px'
    }
}